import { render, staticRenderFns } from "./reset-lpn.vue?vue&type=template&id=959801d2&"
import script from "./js/reset-lpn.js?vue&type=script&lang=js&"
export * from "./js/reset-lpn.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports